import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#0f1a38] group-[.toaster]:text-white group-[.toaster]:border-white/10 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-slate-400",
          actionButton:
            "group-[.toast]:bg-amber-400 group-[.toast]:text-slate-900",
          cancelButton:
            "group-[.toast]:bg-white/10 group-[.toast]:text-slate-300",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
